import { I2ITameeniRedirectUrlResponse } from 'api/newDLTransferAPI'
import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'

type State = {
  redirectUrl: string
} & Status

const initialState: State = {
  redirectUrl: '',
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.I2I_GET_TAMEENI_INSURANCE_REDIRECT_URL_ASYNC,
    Actions.I2I_GET_TAMEENI_INSURANCE_REDIRECT_URL_SUCCESS,
    Actions.I2I_GET_TAMEENI_INSURANCE_REDIRECT_URL_FAIL,
    I2ITameeniRedirectUrlResponse
  >,
) => {
  switch (action.type) {
    case Actions.I2I_GET_TAMEENI_INSURANCE_REDIRECT_URL_ASYNC:
    case Actions.I2I_GET_TAMEENI_INSURANCE_REDIRECT_URL_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.I2I_GET_TAMEENI_INSURANCE_REDIRECT_URL_SUCCESS: {
      return {
        ...state,
        ...action.status,
        redirectUrl: action.payload.redirect_url,
      }
    }
    default:
      return state
  }
}
